import Field from './Field'
import { i18n } from '../i18n';

export default function FieldCheckTree(label, key, items, rules, options, on) {
  Field.call(this, label, key, rules, options, on)
  this.type = 'tree'
  this.subType = 'check-tree'
  this.items = items
}



// WEBPACK FOOTER //
// ./packages/helper/fields/FieldCheckTree.js